const FALLBACK_TIMEZONES = [
  "UTC",
  "America/Los_Angeles",
  "America/New_York",
  "America/Chicago",
  "Europe/London",
  "Europe/Berlin",
  "Europe/Istanbul",
  "Asia/Kolkata",
  "Asia/Tokyo",
  "Australia/Sydney",
]

export const getTimezones = (): string[] => {
  const intl = Intl as unknown as { supportedValuesOf?: (key: string) => string[] }
  if (typeof intl.supportedValuesOf !== "function") return [...FALLBACK_TIMEZONES]

  // V8/ICU leaves "UTC" out of the canonical-location list.
  const supported = intl.supportedValuesOf("timeZone")

  return supported.includes("UTC") ? supported : ["UTC", ...supported]
}
